import {
  PLAN_TO_AUDIENCE_EYEBROW,
  PLAN_TO_EXPORT_EYEBROW,
} from "../../const/planConst";
import { PREPAID_BLOCK_NOTICE } from "../../helpers/prepaidBlockExperiment";

export const pricingCards = {
  monthly: "Monthly",
  yearly: "Yearly",
  savePercent: "Save {percent}%",
  saveAmount: "Save {amount}",
  popular: "Popular",
  perMonth: "/mo",
  billedYearly: "{amount} billed yearly",
  allPlansInclude: "All plans include:",
  aiClipping: "AI Clipping",
  unlimitedAccounts: "Unlimited social accounts",
  analytics: "Analytics",
  needMore: "Need more?",
  letsTalk: "Let's talk!",
  clips: "clips",
  minutes: "minutes",
  uploads: "uploads",
  exports: "exports",
  audience: {
    basic: PLAN_TO_AUDIENCE_EYEBROW.get("basic") ?? "",
    pro: PLAN_TO_AUDIENCE_EYEBROW.get("pro") ?? "",
    "pro-plus": PLAN_TO_AUDIENCE_EYEBROW.get("pro-plus") ?? "",
  },
  exportEyebrow: {
    basic: PLAN_TO_EXPORT_EYEBROW.get("basic") ?? "",
    pro: PLAN_TO_EXPORT_EYEBROW.get("pro") ?? "",
    "pro-plus": PLAN_TO_EXPORT_EYEBROW.get("pro-plus") ?? "",
  },
  exportTooltip:
    '<span style="color:#f8fafc">1 export = download &amp; post a clip.</span> <span style="color:#94a3b8">Re-downloads &amp; posts to more accounts are free.</span>',
  minutesTooltip:
    '<span style="color:#f8fafc">1 minute = 1 minute of source video.</span> <span style="color:#94a3b8">A 20-min video uses 20 minutes. Clipping, downloading, and publishing are unlimited.</span>',
  uploadsTooltip:
    '<span style="color:#f8fafc">1 upload = 1 source video (file or link).</span> <span style="color:#94a3b8">Clipping, downloading, and publishing are unlimited.</span>',
  // By the English label usePlanCheckout returns.
  cta: {
    "Current Plan": "Current Plan",
    Select: "Select",
    "Start 3-day free trial": "Start 3-day free trial",
    "Get started": "Get started",
  } as Record<string, string>,
  prepaidNotice: PREPAID_BLOCK_NOTICE,
};
